var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.isExporting},on:{"click":_vm.pdfExport}},[(_vm.isExporting)?_c('fa',{attrs:{"icon":"circle-notch","spin":""}}):_vm._e(),(!_vm.isExporting)?_c('fa',{attrs:{"icon":"file-pdf"}}):_vm._e(),_c('span',{staticClass:"ml-2"},[_vm._v("PDF Export")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }